var VideoGrid = {};
var videoEmbed = $(document).find('.js-video-embed');
VideoGrid.OnReady = function (event) {};
VideoGrid.OnError = function (event) {};
VideoGrid.OnStateChange = function (event) {
  var targetIframe = event.target.getIframe();
  var videoWrapper = targetIframe.closest('.video-grid-image');
  if (event.data == 0) {
    // Video ends
    videoWrapper.classList.add('yt-player-end');
  } else if (event.data == 2) {
    // Video pause
    videoWrapper.classList.add('yt-player-pause');
  } else if (event.data == 1) {
    // Video playing
    videoWrapper.classList.add('yt-player-play');
  } else {
    videoWrapper.classList.remove('yt-player-end', 'yt-player-pause', 'yt-player-play');
  }
};
VideoGrid.YTplayer = function () {
  var videoEmbed = $(document).find('.js-video-embed');
  if (videoEmbed.length === 0) return;
  $.each(videoEmbed, function () {
    var $videoEmbed = $(this);
    var $videoEmbedID = $videoEmbed.attr('data-video-id');
    var $videoEmbedPlayerID = $videoEmbed.attr('data-player-id');
    $videoEmbed = new window.YT.Player($videoEmbedPlayerID, {
      videoId: $videoEmbedID,
      playerVars: {
        'rel': 0,
        'loop': 1,
        'showinfo': 0,
        'controls': 0,
        'enablejsapi': 1,
        'fs': 0,
        'mute': 1,
        'modestbranding': 1,
        'end': 5,
        'autohide': 0,
        'cc_load_policy': 0,
        'disablekb': 1,
        'iv_load_policy': 3,
        'playsinline': 0,
        'autoplay': 0
      },
      events: {
        'onReady': VideoGrid.OnReady,
        'onError': VideoGrid.OnError,
        'onStateChange': VideoGrid.OnStateChange
      }
    });
    $('#' + $videoEmbedPlayerID).on("mouseover", function () {
      if (matchMedia('screen and (min-width: 992px)').matches) {
        if ($videoEmbed && $videoEmbed.hasOwnProperty('getPlayerState')) {
          $videoEmbed.seekTo(0);
          $videoEmbed.playVideo();
        }
      }
    });
    $('#' + $videoEmbedPlayerID).on("mouseout", function () {
      if (matchMedia('screen and (min-width: 992px)').matches) {
        if ($videoEmbed && $videoEmbed.hasOwnProperty('getPlayerState')) {
          $videoEmbed.pauseVideo();
        }
      }
    });
  });
};
VideoGrid.init = function () {
  var videoEmbed = $(document).find('.js-video-embed');
  if (videoEmbed.length === 0) return;
  if (typeof YT == 'undefined' || typeof YT.Player == 'undefined') {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  window.onYouTubePlayerAPIReady = function () {
    VideoGrid.YTplayer();
  };
};
VideoGrid.dynamicInit = function () {
  VideoGrid.YTplayer();
};
document.addEventListener('DOMContentLoaded', function () {
  VideoGrid.init();
});
window.VideoGrid = VideoGrid;
export default VideoGrid;


// WEBPACK FOOTER //
// ./scripts/components/interstellar/video-grid.js